<template>
  <form @submit="submitForm" id="zugferdform" class="container">
    <!-- ZUGFeRD Version and Profile -->
    <h3 class="mb-3">ZUGFeRD Settings</h3>
    <div class="row g-3">
      <div class="col-md-6">
        <div class="form-group">
          <SearchableDropdown
              input-id="zugFeRDVersion"
              label="ZUGFeRD Version"
              :model-value="form.zugFeRDVersionId"
              @update:modelValue="val => { form.zugFeRDVersionId = val; emitUpdate(); }"
              :options="masterDataStore.ZUGFeRDVersions"
              required
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <SearchableDropdown
              input-id="profile"
              label="Profile"
              :model-value="form.zugFeRDProfileId"
              @update:modelValue="val => { form.zugFeRDProfileId = val; emitUpdate(); }"
              :options="masterDataStore.ZUGFeRDProfiles"
              required
          />
        </div>
      </div>
    </div>
    <div class="row g-3 mt-2">
      <div class="col-md-6">
        <div class="form-group">
          <SearchableDropdown
              input-id="invoiceType"
              :label="$t('form.invoiceType')"
              :model-value="form.invoice?.typeId"
              @update:modelValue="val => { form.invoice.typeId = val; emitUpdate(); }"
              :options="masterDataStore.XRechnungInvoiceTypes"
              bt-number="BT-3"
              :bt-tooltip="$t('tooltips.invoiceType')"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <SearchableDropdown
              input-id="invoiceTypeId"
              :label="$t('form.internInvoiceType')"
              :model-value="form.invoice?.invoiceTypeId"
              @update:modelValue="val => { form.invoice.invoiceTypeId = val; emitUpdate(); }"
              :options="masterDataStore.invoiceTypes"
          />
        </div>
      </div>
    </div>

    <!-- Invoice Form -->
    <h3 class="mt-4 mb-3">{{ $t('form.invoiceDetails') }}</h3>
    <InvoiceForm
        :invoice="form.invoice"
        :is-manual-create-mode="isManualCreateMode"
        @update-invoice="updateInvoice"
    />
  </form>
</template>

<script>
import InvoiceForm from './InvoiceForm.vue';
import ZUGFeRD from '../../models/ZUGFeRD';
import {useMasterDataStore} from "@/stores/masterDataStore";
import SearchableDropdown from "@/components/Shared/SearchableDropdown.vue";
import {Tooltip} from "bootstrap";

export default {
  name: 'ZUGFeRDForm',
  computed: {
    ZUGFeRD() {
      return ZUGFeRD
    }
  },
  components: {SearchableDropdown, InvoiceForm},
  props: {
    zugferd: {
      type: Object,
      required: true
    },
    isManualCreateMode: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      form: this.zugferd,
      masterDataStore: useMasterDataStore(),
    };
  },
  methods: {
    submitForm(event) {
      // Check if the form is valid
      const formElement = event.target;
      if (!formElement.checkValidity()) {
        event.preventDefault();
        formElement.reportValidity();
        return;
      }

      event.preventDefault();
      this.$emit('formSubmitted', this.form);
    },
    updateInvoice(updatedInvoice) {
      this.form.invoice = updatedInvoice;
      this.emitUpdate();
    },
    emitUpdate() {
      //console.log("ZUGFeRDForm update emitted:", this.form);
      this.$emit('update-zugferd', this.form);
    },
    initTooltips() {
      const tooltipTriggerList = this.$el.querySelectorAll('[data-bs-toggle="tooltip"]');
      tooltipTriggerList.forEach((tooltipTriggerEl) => {
        new Tooltip(tooltipTriggerEl);
      });
    }
  },
  watch: {
    zugferd: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.form = {...newVal};
        //console.log("ZUGFeRDForm detected zugferd prop change:", this.form);
        console.log("ZUGFeRDForm detected zugferd prop change NEWVAL:", newVal);
      }
    }
  },
  mounted() {
    this.initTooltips();
    this.masterDataStore.fetchAllMasterData();
    console.log("ZUGFeRDForm mounted:", this.form);
  },

};
</script>
